<template>
  <div>
    <table class="table table-sm color mb-2 crt-report-table" v-if="data && data.length > 0">
      <thead class="header">
      <tr v-if="caption">
        <th colspan="999" class="text-left pt-2 pb-2">
          <span>{{ caption }}</span>
          <b-btn @click="flagExpanded = !flagExpanded" variant="primary" size="sm">{{ flagExpanded ? `Collapse` : `Expand` }}</b-btn>
        </th>
      </tr>
      <tr v-if="flagExpanded">
        <th v-for="(col, name) in data[0]" :key="name" class="the-sticky">
          {{ formatColName(name) }}
        </th>
      </tr>
      </thead>
      <tbody v-if="flagExpanded">
      <tr v-for="(row, index) in data" :key="index">
        <td
            v-for="(val, dbName) in row" :key="dbName"
            :class="[formatColClasses(dbName, val)]"
        >
          {{ formatColValue(val, dbName) }}
        </td>
      </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import ReportColumnsCalculation from '@/utilities/ReportColumnsCalculation';

export default {
  props: {
    data:             Array,
    columnFormatters: Array,
    caption:          String,
  },
  data() {
    return {
      flagExpanded: true
    }
  },
  methods: {
    formatColValue(value, dbName) {
      return ReportColumnsCalculation.formatColValue(value, dbName, this.columnFormatters);
    },
    formatColName(dbName) {
      return ReportColumnsCalculation.formatColName(dbName, this.columnFormatters);
    },
    formatColClasses(dbName, value) {
      return ReportColumnsCalculation.formatColClasses(dbName, value, this.columnFormatters);
    }
  }
}
</script>

<style lang="scss" scoped>
.crt-report-table tbody tr:last-child {
  font-size: 1.2em;
  font-weight: bold;
}
</style>
